<template>
    <div id="container" class="top">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'PageView'
}
</script>
<style scoped>
.top{
    padding-top: 80px;
}
@media screen and (max-width: 997px) {
  .top{
    padding-top: 1px;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/PageView.vue